import React from "react";
import { TextField } from "@mui/material";
import {
  BACKGROUND_COLORS,
  BORDER_COLORS,
  BRAND_COLORS,
  TEXT_COLORS,
} from "../../../style/colors";

const AppTextField = ({ sx, multiline = false, rows, ...props }) => {
  return (
    <TextField
      variant='outlined'
      size='small'
      multiline={multiline}
      rows={rows}
      fullWidth
      sx={{
        "& .MuiInputLabel-root": {
          color: TEXT_COLORS.MUTED,
        },
        "& .MuiInputLabel-root.Mui-focused": {
          color: BRAND_COLORS.ACCENT,
        },
        "& .MuiOutlinedInput-root": {
          minHeight: multiline ? "auto" : 40,
          borderRadius: 2.5,
          backgroundColor: BACKGROUND_COLORS.CARD,
          color: TEXT_COLORS.PRIMARY,
          "& fieldset": {
            borderColor: BORDER_COLORS.SECONDARY,
          },
          "&:hover fieldset": {
            borderColor: BORDER_COLORS.BRAND,
          },
          "&.Mui-focused fieldset": {
            borderColor: BRAND_COLORS.ACCENT,
            borderWidth: 2,
          },
        },
        ...sx,
      }}
      {...props}
    />
  );
};

export default AppTextField;
